// *https://www.registers.service.gov.uk/registers/country/use-the-api*

import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CircularProgress from '@material-ui/core/CircularProgress';
import { GetAllRmList } from '../../constants/api';
import { makeStyles } from '@material-ui/core/styles';
import teal from '@material-ui/core/colors/teal';
import './AutoCompleteFilterBar.css';
import CloseIcon from '@material-ui/icons/Close';
function sleep(delay = 0) {
  return new Promise(resolve => {
    setTimeout(resolve, delay);
  });
}
const primary = teal[300];
const useStyles = makeStyles(theme => ({
  root: {
    height: 40,
    borderColor: '#4ba5af',

    marginButtom: 8,
    '& > * + *': {
      marginTop: theme.spacing(2)
    }
  },
  focused: {
    borderColor: '#4ba5af'
  },
  notchedOutline: {
    borderColor: '#4ba5af'
  },

  inputBase: {
    padding: 10,
    width: '100%',
    borderBottom: '1px solid #dfe2e5',
    '& input': {
      borderRadius: 4,
      backgroundColor: theme.palette.common.white,
      padding: 8,
      transition: theme.transitions.create(['border-color', 'box-shadow']),
      border: '1px solid #ced4da',
      fontSize: 14,
      '&:focus': {
        borderColor: theme.palette.primary.main
      }
    }
  }
}));
export default function Asynchronous({ setRmId, rm }) {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const [selectedOption, setSelectedOption] = React.useState(null);
  const [rmsList, setRmsList] = React.useState('');

  const loading = open && options.length === 0;

  const classes = useStyles();
  React.useEffect(() => {
    let active = true;

    (async () => {
      const response = await GetAllRmList();

      let rms = await response;

      if (active) {
        setOptions(Object.keys(rms).map(key => rms[key]));
      }
    })();
    return () => {
      active = false;
    };
  }, [rm]);

  React.useEffect(() => {
    if (Array.isArray(options) && options.length !== 0 && rm) {
      options.map(each => {
        if (each.userId.toString() == rm) {
          setSelectedOption(each);
        }
      });
    }
  }, [options, rm]);

  return (
    <div className={classes.root}>
      <Autocomplete
        size="small"
        id="asynchronous-demo"
        style={{
          width: 250,
          marginLeft: 'auto',
          marginRight: 'auto'
        }}
        className={
          classes.notchedOutline + ' ' + classes.focused + ' ' + classes.root
        }
        onChange={(e, value) => {
          if (value) setRmId(value.userId), setSelectedOption(value);
          else setRmId('');
        }}
        value={selectedOption}
        getOptionLabel={option => (option?.fullName ? option.fullName : '')}
        options={options}
        loading={loading}
        closeIcon={
          <div onClick={() => setSelectedOption(false)}>
            <CloseIcon />
          </div>
        }
        renderInput={params => (
          <TextField
            {...params}
            label="Filter By RM"
            variant="outlined"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              )
            }}
          />
        )}
      />
    </div>
  );
}
